import db from './indexDB'

export default {
    async clearScoutings() {
        await db.scoutings.clear();
    },
    async putScoutings(scoutings) {
        await db.scoutings.bulkPut(scoutings);
    },
    async getScoutings() {
        return await db.scoutings.toArray();
    },

    async clearPestConfigurations() {
        await db.pestConfigurations.clear();
    },
    async addPestConfigurations(pestConfigurations) {
        await db.pestConfigurations.bulkPut(pestConfigurations);
    },
    async getPestConfigurations() {
        return await db.pestConfigurations.toArray();
    },

    async clearScoutingCropStages() {
        await db.scoutingCropStages.clear();
    },
    async addScoutingCropStages(cropStages) {
        await db.scoutingCropStages.bulkPut(cropStages);
    },
    async getScoutingCropStages() {
        return await db.scoutingCropStages.toArray();
    },

    async addUnsyncedScouting(scouting) {
        // needs to be added to the unsent list (will not overwrite because there is no ID field for this table)
        // and also to the actual list (will overwrite if it finds a record with a matching ID)
        await db.scoutingsUnsent.put(scouting);
        await db.scoutings.put(scouting);
    },
    async getUnsyncedScoutings() {
        return await db.scoutingsUnsent.toArray();
    },
    async clearUnsyncedScouts() {
        await db.scoutings.where("ScoutingID").below(0).delete();
        return await db.scoutingsUnsent.clear();
    },
}